import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { DynamicInput, DynamicInput2 } from "../../components/DynamicInput";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeDRL = ({
    processo,
    laudo,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadAcao, setLoadAcao] = useState(null);
    const [observacao, setObservacao] = useState("");

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '60%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setObservacao("");
        setisLoading(false);
        setIsOpen(false); 
    }

    const campoObrigatorio = (campo) => {
        Swal.fire({
            title: "Atenção",
            html: `${campo}`,
            icon: "warning",
            confirmButtonText: "OK",
        });
    };

    const onClickAction = () => {
        
    };

    const events = [
        { date: '01/01/2025', text: 'Solicitação DRL' },
        { date: '08/01/2025', text: 'Reiteração DRL' },
        { date: '15/01/2025', text: 'Reiteração DRL' },
        { date: '22/01/2025', text: 'Reiteração DRL' },
        { date: '29/01/2025', text: 'Reiteração DRL' },
        { date: '30/01/2025', text: 'Recepção DRL' },
        { date: '30/01/2025', text: 'DRL Causa Completa' },
        { date: '01/02/2025', text: 'Reiteração DRL' },
        { date: '04/02/2025', text: 'Recepção DRL' },
        { date: '04/02/2025', text: 'DRL Liquidação Completa' },
        { date: '05/01/2025', text: 'Solicitação Comp. DRL' },
    ];
    // Largura da bolinha
    const dotSize = 14;
    // Posição central da linha vertical (a partir da esquerda)
    const lineCenterPosition = 16; 
    // Cálculo para centralizar a bolinha na linha: (centro da linha) - (metade da bolinha)
    const dotLeftPosition = lineCenterPosition - (dotSize / 2);

    useEffect(() => {
        if(isOpen) {}
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Cancelar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24" height="24" className="me-2">
                                        <path fill={'#999'} d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176z"/></svg>
                                    DRL</p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ processo?.processoSigla || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ processo?.liderProcesso || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ processo?.cliente || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ processo?.segurado || "-" }</div>
                    </div>
                    <div className="row" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ processo?.disciplina }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Abertura</span><br/>{ new Date(processo?.dataAbertura).toLocaleDateString('pt-BR') }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Status</span><br/>{ processo?.statusProcesso }</div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <div className="row mb-2">
                        <div className="col-7">
                            <p>&nbsp;</p>
                            {/* Card Resumo DRL com DynamicInput */}
                            <div className="card mb-2 p-3" style={{ maxWidth: '600px' }}>
                                
                                {/* Cabeçalho */}
                                <div className="row mb-3 align-items-end">
                                    <div className="col-5">
                                        <h5 className="mb-0 text-dark fw-bold" style={{ paddingLeft: '10px' }}>Resumo DRL</h5>
                                    </div>
                                    <div className="col-3 text-center">
                                        <div className="border rounded p-2 fw-bold text-secondary bg-white">
                                            Solicitação
                                        </div>
                                    </div>
                                    <div className="col-3 text-center">
                                        <div className="border rounded p-2 fw-bold text-secondary bg-white">
                                            Recepção
                                        </div>
                                    </div>
                                </div>

                                {/* ========================================== */}
                                {/* LINHA 1: REGULAÇÃO                         */}
                                {/* ========================================== */}
                                <div className="row align-items-center mb-3">
                                    
                                    {/* Coluna de Rótulos (Label Esquerda) */}
                                    <div className="col-5">
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="border rounded d-flex align-items-center justify-content-center text-secondary" 
                                                    style={{ height: '80px', width: '100%', border: '1px solid #ced4da' }}>
                                                Regulação
                                            </div>
                                            <div className="d-flex flex-column gap-2" style={{ minWidth: '70px' }}>
                                                <div className="border rounded px-2 py-1 text-center small text-secondary bg-light">Basica</div>
                                                <div className="border rounded px-2 py-1 text-center small text-secondary bg-light">Comp.</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coluna Solicitação (Inputs) */}
                                    <div className="col-3">
                                        <div className="d-flex flex-column gap-2 align-items-center h-100 justify-content-center">
                                            
                                            {/* Input: Regulação > Solicitação > Basica */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label="" // Label vazio pois já tem na esquerda
                                                    name="cmp_regulacao_solic_basica"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>

                                            {/* Input: Regulação > Solicitação > Comp */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_regulacao_solic_comp"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coluna Recepção (Inputs) */}
                                    <div className="col-3">
                                        <div className="d-flex flex-column gap-2 align-items-center h-100 justify-content-center">
                                            
                                            {/* Input: Regulação > Recepção > Basica */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_regulacao_recep_basica"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center border border-success bg-success bg-opacity-10"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>

                                            {/* Input: Regulação > Recepção > Comp */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_regulacao_recep_comp"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center border border-success bg-success bg-opacity-10"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ========================================== */}
                                {/* LINHA 2: LIQUIDAÇÃO                        */}
                                {/* ========================================== */}
                                <div className="row align-items-center">
                                    
                                    {/* Coluna de Rótulos (Label Esquerda) */}
                                    <div className="col-5">
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="border rounded d-flex align-items-center justify-content-center text-secondary" 
                                                    style={{ height: '80px', width: '100%', border: '1px solid #ced4da' }}>
                                                Liquidação
                                            </div>
                                            <div className="d-flex flex-column gap-2" style={{ minWidth: '70px' }}>
                                                <div className="border rounded px-2 py-1 text-center small text-secondary bg-light">Basica</div>
                                                <div className="border rounded px-2 py-1 text-center small text-secondary bg-light">Comp.</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coluna Solicitação (Inputs) */}
                                    <div className="col-3">
                                        <div className="d-flex flex-column gap-2 align-items-center h-100 justify-content-center">
                                            
                                            {/* Input: Liquidação > Solicitação > Basica */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_liquidacao_solic_basica"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>

                                            {/* Input: Liquidação > Solicitação > Comp (Exemplo Amarelo/5) */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_liquidacao_solic_comp"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center border border-warning bg-warning bg-opacity-10"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coluna Recepção (Inputs) */}
                                    <div className="col-3">
                                        <div className="d-flex flex-column gap-2 align-items-center h-100 justify-content-center">
                                            
                                            {/* Input: Liquidação > Recepção > Basica */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_liquidacao_recep_basica"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center border border-success bg-success bg-opacity-10"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>

                                            {/* Input: Liquidação > Recepção > Comp */}
                                            <div style={{ width: '70px' }}>
                                                <DynamicInput2
                                                    type="number"
                                                    label=""
                                                    name="cmp_liquidacao_recep_comp"
                                                    placeholder="0"
                                                    className="p-1 ps-3 text-center border border-warning bg-warning bg-opacity-10"
                                                    min={0}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Card Interações */}
                            <div className="card mb-2 p-3" style={{ maxWidth: '600px' }}>    
                                {/* Cabeçalho Geral: Título na esquerda, Cabeçalhos das colunas na direita */}
                                <div className="row mb-2 align-items-end">
                                    {/* Coluna 1: Título (Alinhado com a caixa DRL abaixo) */}
                                    <div className="col-5">
                                        <h5 className="mb-0 text-dark fw-bold" style={{ paddingLeft: '10px' }}>Interações</h5>
                                    </div>
                                    
                                    {/* Coluna 2: Cabeçalho Solici. */}
                                    <div className="col-3 text-center">
                                        <div className="border rounded p-2 fw-bold small text-secondary bg-white">
                                            Solici.
                                        </div>
                                    </div>

                                    {/* Coluna 3: Cabeçalho Reit. */}
                                    <div className="col-3 text-center">
                                        <div className="border rounded p-2 fw-bold small text-secondary bg-white">
                                            Reit.
                                        </div>
                                    </div>
                                </div>

                                {/* Linha de Conteúdo */}
                                <div className="row align-items-center">
                                    
                                    {/* Coluna Esquerda: Caixa DRL + Botões Basica/Comp */}
                                    <div className="col-5">
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Caixa DRL */}
                                            <div className="border rounded d-flex align-items-center justify-content-center text-secondary" 
                                                style={{ height: '80px', width: '100%', border: '1px solid #ced4da' }}>
                                                DRL
                                            </div>
                                            
                                            {/* Botões Pequenos */}
                                            <div className="d-flex flex-column gap-2" style={{ minWidth: '70px' }}>
                                                <div className="border rounded px-2 py-1 text-center small text-secondary bg-white">Basica</div>
                                                <div className="border rounded px-2 py-1 text-center small text-secondary bg-white">Comp.</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coluna Central: Valores Solici. */}
                                    <div className="col-3">
                                        <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                                            {/* Valor tracejado */}
                                            <div className="rounded px-3 py-1 bg-white text-dark" 
                                                style={{ border: '1px dashed #ccc', width: '60px', textAlign: 'center' }}>
                                                1
                                            </div>
                                            {/* Valor Destaque Vermelho */}
                                            <div className="rounded px-3 py-1 text-white" 
                                                style={{ backgroundColor: '#ff6b6b', width: '60px', textAlign: 'center' }}>
                                                1
                                            </div>
                                        </div>
                                    </div>

                                    {/* Coluna Direita: Valores Reit. */}
                                    <div className="col-3">
                                        <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                                            {/* Valor tracejado */}
                                            <div className="rounded px-3 py-1 bg-white text-dark" 
                                                style={{ border: '1px dashed #ccc', width: '60px', textAlign: 'center' }}>
                                                5
                                            </div>
                                            {/* Valor tracejado (0) */}
                                            <div className="rounded px-3 py-1 bg-white text-dark" 
                                                style={{ border: '1px dashed #ccc', width: '60px', textAlign: 'center' }}>
                                                0
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-5 text-center">
                            <p>Histórico</p>
                            <div className="card mb-2 p-3" style={{ maxWidth: '600px' }}>
                                <div style={{ position: 'relative' }}>
                                    
                                    {/* A Linha Vertical Contínua */}
                                    <div 
                                        style={{ 
                                            position: 'absolute', 
                                            left: `${lineCenterPosition - 1}px`, // Centraliza a linha de 2px
                                            top: '10px', // Ajuste fino para alinhar com o topo da primeira bolinha
                                            bottom: '10px', // Ajuste fino para alinhar com a base da última bolinha
                                            width: '2px', 
                                            backgroundColor: '#212529',
                                            zIndex: 0
                                        }} 
                                    />

                                    {/* Lista de Eventos */}
                                    <div className="d-flex flex-column gap-3">
                                    {events.map((event, index) => (
                                        <div key={index} style={{ position: 'relative', paddingLeft: '35px', minHeight: `${dotSize}px`, display: 'flex', alignItems: 'center' }}>
                                        
                                        {/* Bolinha (Dot) com posicionamento absoluto para centralizar */}
                                        <div 
                                            className="rounded-circle bg-dark" 
                                            style={{ 
                                                position: 'absolute',
                                                left: `${dotLeftPosition}px`,
                                                top: '50%', // Centraliza verticalmente no item
                                                transform: 'translateY(-50%)', // Corrige a centralização vertical
                                                width: `${dotSize}px`, 
                                                height: `${dotSize}px`, 
                                                zIndex: 1 // Fica por cima da linha
                                            }} 
                                        />
                                        
                                        {/* Texto */}
                                        <div className="text-dark fw-bold" style={{ fontSize: '15px' }}>
                                            {event.date} - <span className="fw-normal">{event.text}</span>
                                        </div>
                                        </div>
                                    ))}
                                    </div>

                                </div>
                                </div>
                        </div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                    
                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Concluir'} 
                                        type="button" 
                                        onClick={onClickAction.bind()}/>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};